import { Component, OnInit } from '@angular/core';

import { environment } from '../../../environments/environment';
import { Account } from '../../helpers/auth';
import { Page, PageType } from '../../helpers/page';

import { AuthService } from '../../services/auth.service';
import { DocsService } from '../../services/docs.service';
import { LoaderService } from '../../services/loader.service';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'kd-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {

    account: Account;
    adminUrl = `${environment.apiUrl}${environment.adminPath}`;
    menuOpen = false;
    page: Page;

    constructor(
        private authService: AuthService,
        private docsService: DocsService,
        private loaderService: LoaderService,
        private userService: UserService,
    ) { }

    ngOnInit() {
        this.account = this.authService.getAccount();

        this.docsService.getPageChange().subscribe(() => {
            this.page = this.docsService.getPage();
        });
    }

    canEdit(): boolean {
        return (
            this.isQuip() &&
            this.account.permissions['pages.change_page']
        );
    }

    closeMenu(): void {
        this.menuOpen = false;
    }

    isQuip(): boolean {
        return (
            this.page &&
            this.page.page_type === PageType.Quip
        );
    }

    login(): void {
        this.authService.login();
    }

    async logout(): Promise<void> {
        await this.authService.logout();
        this.account = this.authService.getAccount();
    }

    openCredentials(): void {
        this.userService.openCredentials();
    }

    async refresh(): Promise<void> {
        this.closeMenu();

        this.loaderService.start();
        await this.docsService.clearCache(this.page.id);
        this.loaderService.stop();
    }

    toggleMenu(): void {
        this.menuOpen = !this.menuOpen;
    }
}
